export enum ActivityKind {
  comment = 'comment',
  change = 'change',
  status_change = 'status_change',
}
